module.exports = __webpack_public_path__ + "img/logo_dafni_02.6a87a4e8.png";